import { useState } from "react";
import "./Styles/navBar.css";

const NavBar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    const handleDropdownToggle = (index) => {
        setActiveDropdown((prev) => (prev === index ? null : index));
    };

    const toggleMobileNav = () => {
        setIsMobileNavOpen((prev) => !prev);
    };

    const dropdowns = [
        {
            name: "Products",
            links: [
                { label: "Wrap & Ensembles", href: "/product/wrap-and-ensembles" },
                { label: "Gift Bags", href: "/product/gift-bags" },
                { label: "Gift Boxes", href: "/product/gift-boxes" },
                { label: "Greeting Cards", href: "/product/greeting-cards" },
                { label: "Gift Bows", href: "/product/gift-bows" },
                { label: "Cello Wrap", href: "/product/cello-gift-wrap" },
                { label: "Gift Tags", href: "/product/gift-tag" },
                { label: "Partyware", href: "/product/partyware" },
            ],
        },
    ];

    return (
        <section className="navigation">
            <div className="nav-container">

                {/* Brand Logo */}
                <div className="brand">
                    <img
                        src="/glitterpaperdesignslogo.png"
                        alt="Brand Logo"
                        className="brand-logo"
                    />
                </div>

                <nav>
                    {/* Hamburger Button */}
                    <div className="nav-mobile">
                        <a id="nav-toggle" href="#!" onClick={toggleMobileNav}>
                            <span></span>
                        </a>
                    </div>

                    {/* Navigation List */}
                    <ul className={`nav-list ${isMobileNavOpen ? "open" : ""}`}>
                        <li><a href="/">Home</a></li>

                        {/* Dropdowns */}
                        {dropdowns.map((item, i) => (
                            <li key={item.name}>
                                <a
                                    href="#!"
                                    onClick={() => handleDropdownToggle(i)}
                                >
                                    {item.name}
                                </a>
                                <ul
                                    className="nav-dropdown"
                                    style={{ display: activeDropdown === i ? "block" : "none" }}
                                    >
                                    {item.links.map((link) => (
                                        <li key={link.label}>
                                        <a href={link.href}>{link.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}

                        <li><a href="/about-us">About Us</a></li>
                        <li><a href="/team">Our Team</a></li>
                        <li><a href="/sustainability">Sustainability</a></li>
                        <li><a href="/contact-us">Contact Us</a></li>
                    </ul>
                </nav>
            </div>
        </section>
    );
};

export default NavBar;
